export const UM_QUERIES_LIST_ENDPOINT =
  "/arcplus/um/admission-review/queries";

export const UM_QUERY_DETAIL_ENDPOINT = (queryId: string) =>
  `/arcplus/um/admission-review/queries/${queryId}`;
